import React from 'react'
import classNames from 'classnames/bind'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { IProps } from './Interface'
import { useStyles } from './Styles'
import { Typography, Grid } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'

const MenuItem: React.FC<IProps> = ({ id, href, title, onClick, isSelected, disabled, showWarningIcon }) => {
  const classes = useStyles({})
  const cx = classNames.bind(classes)
  const className = cx({
    menuItem: true,
    menuItemSelected: isSelected,
    disabled
  })

  const menuItemClasses = cx({
    menuItemText: true,
    menuItemTextDisabled: disabled
  })

  return (
    <Grid item className={className} onClick={onClick} component="a" href={href ? `#${href}` : null}>
      {showWarningIcon && (
        <Tooltip
          id={`${title}-questions-are-incomplete-helper`}
          title="Some questions are still incomplete or invalid."
          aria-label="questions-are-incomplete-helper"
        >
          <ErrorOutlineIcon classes={{ root: classes.icon }} />
        </Tooltip>
      )}
      <Typography id={`${id}-menu-item-title`} variant={'body1'} className={menuItemClasses}>
        {title}
      </Typography>
    </Grid>
  )
}

MenuItem.defaultProps = {
  title: '',
  showWarningIcon: false,
  onClick: () => {},
  isSelected: false,
  disabled: false
}

export default MenuItem
